import styled, { css } from "styled-components";
import {
  BLACK,
  DARK_BLUE,
  DINGY_GRAY,
  MATTE_BLACK,
  NEAR_BLACK,
  NEAR_WHITE,
  WHITE,
} from "../../../config";

export const Container = styled.div<{ isRowClickable?: boolean }>`
  width: 100%;
  height: 82%;
  overflow: hidden;
  border-radius: 0px 0px 0px 8px;

  .ReactVirtualized__Grid.ReactVirtualized__Table__Grid {
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.2s ease;
      height: 100%;
    }
  }

  .ReactVirtualized__Grid__innerScrollContainer {
    overflow: unset !important;
  }

  .grid-body-row {
    color: ${NEAR_WHITE};
  }

  .selected-row {
    background: ${NEAR_WHITE} !important;
    color: ${NEAR_BLACK} !important;
  }
`;

export const HeaderRow = styled.div<{
  scrollbarSize: number;
  isSmall?: boolean;
}>`
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  background-color: ${BLACK};
  box-sizing: border-box;
  padding-right: ${({ scrollbarSize, isSmall }) =>
    `${scrollbarSize * 2 + (isSmall ? 8 : 0)}px !important`};
  padding-left: ${({ isSmall }) => (isSmall ? "8px" : "32px")};
`;

export const HeaderCell = styled.div<{
  onClick?: () => void;
  isSmall?: boolean;
}>`
  display: flex;
  align-items: center;
  height: 38px;
  text-align: left;
  color: ${WHITE};
  padding: 8px;
  box-sizing: border-box;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: ${({ isSmall }) => (isSmall ? "12px" : "14px")};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "unset")};
  user-select: none;
  transition: 0.2s ease;
  position: relative;

  svg {
    margin-left: 6px;
  }

  &:hover {
    background: ${({ onClick }) => (onClick ? NEAR_BLACK : BLACK)};
  }
`;

export const BodyRow = styled.div<{
  isSelected: boolean;
  isClickable: boolean;
  isEven: boolean;
  hasDetails: boolean;
  isExpanded: boolean;
  rowHeight: number;
  hasHover?: boolean;
  disableHover?: boolean;
  isSmall?: boolean;
}>`
  display: flex;
  flex-direction: ${({ hasDetails }) => (hasDetails ? "column" : "row")};
  align-items: center;
  border-left: ${({ hasDetails }) =>
    hasDetails ? "2px dashed transparent" : "unset"};
  background: ${({ isEven }) => (isEven ? DINGY_GRAY : MATTE_BLACK)};
  box-sizing: border-box;
  max-width: 100%;
  overflow: unset !important;
  transition: all 0.2s ease, background-color 0s, border-width 0s, padding 0s;
  padding-left: ${({ isSmall }) => (isSmall ? "8px" : "32px")};

  ${({ disableHover }) =>
    !disableHover &&
    css<{
      hasHover?: boolean;
      hasDetails: boolean;
    }>`
      &:hover {
        background-color: ${({ hasHover }) => (hasHover ? NEAR_WHITE : "")};
        color: ${({ hasHover }) => (hasHover ? DINGY_GRAY : "")};
        z-index: 1;
        justify-content: center;
        filter: ${({ hasDetails }) => (hasDetails ? "brightness(0.9)" : "")};

        a {
          color: ${({ hasHover }) => (hasHover ? DINGY_GRAY : "")};
        }
        .icon-arrowUp {
          display: block;
          position: absolute;
          top: 40px;
          color: ${DARK_BLUE};
        }

        .grid-body-row-hover {
          background-color: ${DARK_BLUE};
          transition: 0.2s ease;
          border-radius: 4px;
          display: flex;
          align-items: center;
          padding: 0px 11px;
          position: absolute;
          top: 65px;
          margin: 15px;

          p {
            color: ${NEAR_WHITE};
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    `}

  ${({ isClickable }) =>
    isClickable
      ? css<{ isEven: boolean }>`
          cursor: pointer;
        `
      : null};

  .grid-body-row-columns {
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: calc(100% + 2px);
    min-height: ${({ rowHeight }) => `${rowHeight}px`};
    max-height: ${({ rowHeight }) => `${rowHeight}px`};
    margin-left: ${({ hasDetails }) => (hasDetails ? "-2px" : "unset")};

    > svg {
      color: ${NEAR_WHITE};
      transition: 0.2s ease;
      width: 1rem;
      margin-left: -1rem;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .grid-body-row-details {
    width: 100%;
    flex-grow: 1;
    overflow: hidden;
    transition: height 0.3s ease;
  }

  .grid-body-row-details.expanded {
    max-height: 500px;
  }

  .grid-body-row-hover {
    display: none;
  }

  .icon-arrowUp {
    display: none;
  }

  .ReactVirtualized__Table__rowColumn {
    margin: 0;
    padding: 8px;
    box-sizing: border-box;
    font-weight: 500;

    &:nth-child(1) {
      font-weight: bold;
      line-height: 16px;
    }
  }
`;

export const BodyCell = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0px;
  &,
  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    justify-content: center;
    overflow: hidden;
  }
`;
